export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10271.14278f59.jpg";